// Toggle a solid-white header once the page is scrolled off the top.
// The scroll container varies by page/state (window/<html> on some pages, a
// .page-wrapper element on others), so a capture-phase document listener is
// used — it catches scroll events from ANY element, since scroll doesn't bubble.
(function () {
  var group = document.getElementById('header-group');
  if (!group) return;

  function currentY() {
    return (
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      (document.querySelector('.page-wrapper') || {}).scrollTop ||
      0
    );
  }

  function onScroll() {
    // Hysteresis: on past 40, off only back above 10. A single threshold made
    // the border/shadow transition re-fire on every trackpad wobble around
    // 40px, which read as the header shimmering mid-scroll.
    var y = currentY();
    if (y > 40) group.classList.add('as-scrolled');
    else if (y < 10) group.classList.remove('as-scrolled');
  }

  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
